import { useCallback, useState } from 'react';
import { FileToUpload, FileWithDocType } from 'ui/atoms/file-upload';

export interface FileIndexed {
  index: number;
  document: FileWithDocType;
}

export const useMultipleBatchFileUploads = () => {
  const [documentsUploaded, setDocumentsUploaded] = useState<FileIndexed[]>([]);

  const onChangeBatchDocuments = useCallback(
    (documents: FileToUpload[]) => {
      if (!documents || documents.length === 0) {
        setDocumentsUploaded([]);
        return;
      }

      const newDocumentType = documents[0]?.documentType || null;

      // change document type
      if (documentsUploaded.length > 0 && documentsUploaded.length === documents.length) {
        if (newDocumentType !== documentsUploaded[0]?.document.documentType) {
          const filesToUpload = documentsUploaded.map((docObj) => ({
            ...docObj,
            document: {
              ...docObj.document,
              documentType: newDocumentType,
            },
          }));

          setDocumentsUploaded(filesToUpload);
        }
        return;
      }

      // change uploaded files
      const filesToUpload = documents.map(({ file, documentType }, index) => ({
        index: index,
        document: {
          file,
          documentType: documentType || newDocumentType,
        } as FileWithDocType,
      }));

      setDocumentsUploaded(filesToUpload);
    },
    [documentsUploaded],
  );

  const onRemoveDocument = useCallback(
    (indexToRemove: number) => {
      setDocumentsUploaded(documentsUploaded.filter((docObj) => docObj.index !== indexToRemove));
    },
    [documentsUploaded],
  );

  return {
    documentsUploaded,
    onChangeBatchDocuments,
    onRemoveDocument,
  };
};
